// src/components/ProductDialog.js
import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from '@mui/material';

function ProductDialog({ open, onClose, onSave, initialProduct }) {
  const [product, setProduct] = useState({
    name: '',
    sku: '',
    quantity: 0,
    price: 0,
    note: '',
    unit: '',
    chemicalName: '',     // Tên hóa học (MỚI)
    casNumber: '',        // Mã số CAS (MỚI)
    chemicalFormula: ''   // Công thức hóa học (MỚI)
  });

  useEffect(() => {
    if (initialProduct && open) {
      setProduct({
        name: initialProduct.name || '',
        sku: initialProduct.sku || '',
        quantity: Number(initialProduct.quantity ?? 0),
        price: Number(initialProduct.price ?? 0),
        note: initialProduct.note || '',
        unit: initialProduct.unit || '',
        chemicalName: initialProduct.chemicalName || '',
        casNumber: initialProduct.casNumber || '',
        chemicalFormula: initialProduct.chemicalFormula || ''
      });
    } else if (open) {
      setProduct({
        name: '',
        sku: '',
        quantity: 0,
        price: 0,
        note: '',
        unit: '',
        chemicalName: '',
        casNumber: '',
        chemicalFormula: ''
      });
    }
  }, [initialProduct, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const isNumeric = name === 'quantity' || name === 'price';
    setProduct(prev => ({
      ...prev,
      [name]: isNumeric ? Number(value) : value
    }));
  };

  const handleSave = () => {
    onSave(product);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{initialProduct ? 'Chỉnh Sửa Sản Phẩm' : 'Thêm Sản Phẩm Mới'}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          name="name"
          label="Tên Sản Phẩm"
          type="text"
          fullWidth
          value={product.name}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="sku"
          label="Mã SP (SKU)"
          type="text"
          fullWidth
          value={product.sku}
          onChange={handleChange}
        />

        {/* Các trường hóa học */}
        <TextField
          margin="dense"
          name="chemicalName"
          label="Tên hóa học"
          type="text"
          fullWidth
          value={product.chemicalName}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="casNumber"
          label="Mã số CAS"
          type="text"
          fullWidth
          value={product.casNumber}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="chemicalFormula"
          label="Công thức hóa học"
          type="text"
          fullWidth
          value={product.chemicalFormula}
          onChange={handleChange}
        />

        <TextField
          margin="dense"
          name="note"
          label="Chú thích"
          type="text"
          fullWidth
          value={product.note}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="unit"
          label="Đơn vị (VD: cái, kg, hộp)"
          type="text"
          fullWidth
          value={product.unit}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="quantity"
          label="Tồn kho"
          type="number"
          fullWidth
          value={product.quantity}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="price"
          label="Đơn giá"
          type="number"
          fullWidth
          value={product.price}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Hủy</Button>
        <Button onClick={handleSave} variant="contained">Lưu</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ProductDialog;
